var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":_vm.topImg,"alt":""}})]),_c('p',{staticClass:"end"},[_vm._v("报名通道已关闭，感谢您的参与")]),_c('div',{staticClass:"bottom"},[_c('img',{attrs:{"src":_vm.bottomImg,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }